import React from 'react';
import './NewHomepage.css';

// Import components
import Header from './newHome/components/Header';
import Hero from './newHome/components/Hero';
import Details from './newHome/components/Details';
import Testimonials from './newHome/components/Testimonials';
import Details2 from './newHome/components/Details2';
import Footer from './newHome/components/Footer';

// Import pages
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Chat from './pages/Chat';

const NewHomepage = () => {
  return (
    <div className="new-homepage">
      <Header />
      <main className="main-content">
        <Hero />
        <Details />
        <Details2 />
        <Testimonials />
      </main>
      <Footer />
    </div>
  );
};

export default NewHomepage; 